import { render, staticRenderFns } from "./UploadInvoice.vue?vue&type=template&id=cdeb952e&scoped=true&"
import script from "./UploadInvoice.vue?vue&type=script&lang=js&"
export * from "./UploadInvoice.vue?vue&type=script&lang=js&"
import style0 from "./UploadInvoice.vue?vue&type=style&index=0&id=cdeb952e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeb952e",
  null
  
)

export default component.exports